export const Lawyer = [
   {
      "name": "Paras Pipre",
      "regno": "MP001/01",
      "mobile": 6264625677,
      "dob": "21/11/2000"
   },
   {
      "name": "Naincy Jain",
      "regno": "MP002/02",
      "mobile": 8426942808,
      "dob": "18/01/2002"
   },
   {
      "name": "Shri Rajendra Kumar Soni",
      "regno": "MP 281/79",
      "mobile": 7000617200,
      "dob": "14/08/1952"
   },
   {
      "name": "Shri Gopal Pataskar",
      "regno": "MP 423/86",
      "mobile": 9301549720,
      "dob": "01/07/1958"
   },
   {
      "name": "Shri Rakesh Mishra",
      "regno": "MP 1671/89",
      "mobile": 9424409352,
      "dob": "30/01/1961"
   },
   {
      "name": "Shri Jaggeshwar Prasad Chaudha",
      "regno": "MP 1757/90",
      "mobile": 9329290262,
      "dob": "23/05/1965"
   },
   {
      "name": "Shri Arun Kumar Mishra",
      "regno": "MP 571/91",
      "mobile": 9691134446,
      "dob": "12/07/1965"
   },
   {
      "name": "Shri Abdul Farukh Khan",
      "regno": "MP 384/94",
      "mobile": 9300731874,
      "dob": "27/09/1967"
   },
   {
      "name": "Shri Damodar Prasad Sahu",
      "regno": "MP 2162/95",
      "mobile": 9303784848,
      "dob": "31/12/1958"
   },
   {
      "name": "Shri Manoj Kumar Hazari",
      "regno": "MP 2569/97",
      "mobile": 9329134086,
      "dob": "12/03/1968"
   },
   {
      "name": "Shri Manoj Kumar Tiwari",
      "regno": "MP 1937/99",
      "mobile": 9300409312,
      "dob": "28/03/1973"
   },
   {
      "name": "Shri P. N. Rawat",
      "regno": "MP 1048/01",
      "mobile": 8966089777,
      "dob": "07/07/1969"
   },
   {
      "name": "Shri Bahram Khan",
      "regno": "MP 1077/01",
      "mobile": 9329132534,
      "dob": "30/06/1971"
   },
   {
      "name": "Shri Pradeep Nema",
      "regno": "MP 1576/01",
      "mobile": 9754964949,
      "dob": "30/07/1975"
   },
   {
      "name": "Shri Laxmikant Pathak",
      "regno": "MP 1581/01",
      "mobile": 9302272757,
      "dob": "16/06/1976"
   },
   {
      "name": "Shri Kamlesh Kumar Sahu",
      "regno": "MP 1584/01",
      "mobile": 9300651650,
      "dob": "01/08/1980"
   },
   {
      "name": "Shri Rajendra Kumar Chaube",
      "regno": "MP 1126/02",
      "mobile": 9300284494,
      "dob": "13/01/1964"
   },
   {
      "name": "Shri Deepchand Chaudhari",
      "regno": "MP 2023/02",
      "mobile": 8720871728,
      "dob": "10/04/1974"
   },
   {
      "name": "Shri Mahendra Kumar Sharma",
      "regno": "MP 2028/02",
      "mobile": 9300441651,
      "dob": "01/01/1970"
   },
   {
      "name": "Shri Raja Lodhi Thakur",
      "regno": "MP 2474/02",
      "mobile": 9009861165,
      "dob": "20/12/1972"
   },
   {
      "name": "Shri Ajad Khan",
      "regno": "MP 2614/02",
      "mobile": 9300632306,
      "dob": "19/07/1975"
   },
   {
      "name": "Shri Sheikh Jameel Kuraishi",
      "regno": "MP 3202/02",
      "mobile": 9425636679,
      "dob": "13/12/1975"
   },
   {
      "name": "Shri Rajesh Kumar Kurmi (Khulla)",
      "regno": "MP 2170/04",
      "mobile": 9691226514,
      "dob": "12/11/1977"
   },
   {
      "name": "Shri Raghav Nema",
      "regno": "MP 2071/05",
      "mobile": 9329565414,
      "dob": "04/07/1979"
   },
   {
      "name": "Shri Vinod Kumar Patel",
      "regno": "MP 2138/05",
      "mobile": 9329644742,
      "dob": "06/07/1980"
   }
]

